module.exports = __webpack_public_path__ + "img/TE-Lockup-RGB-BLACK.22cabdd4.svg";